import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { login } from "../store/auth";
import logoAS from "../assets/logo-as.png";
import LanguageSwitcher from "../components/LanguageSwitcher";
import WarpBackground from "../components/WarpBackground";
import Nebulosa from "../components/Nebulosa";

export default function Login() {
  const [email,   setEmail]   = useState("");
  const [senha,   setSenha]   = useState("");
  // "Olho magico" (mostrar/ocultar senha) -- portado do commit ca268d4
  // (22/07/2026, feito direto na VPS), que essa copia local nunca tinha
  // puxado de volta.
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro,    setErro]    = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  // Marca fixa da SAAS.GL (logo + nome). Nao vem mais do config "sistema" --
  // esse campo era editavel pelo admin e acabou sobrescrito incorretamente
  // (mostrava "A.S"). Ver auditoria de 18/08/2026. Subtitulo agora vem do
  // i18n (t("login.subtitle")) pra acompanhar o idioma escolhido.
  const sistema = { nome: "SAAS.GL", logoUrl: logoAS };
  const navigate = useNavigate();

  const enviar = async (e) => {
    e.preventDefault(); setLoading(true); setErro("");
    try { await login(email, senha); navigate("/"); }
    catch (err) { setErro(err.response?.data?.detail || t("login.error")); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ alignItems: "center", display: "flex", justifyContent: "center", minHeight: "100vh", position: "relative" }}>
      <style>{`
        .lg-field{margin-bottom:18px;position:relative;}
        .lg-field .lg-ic{color:var(--text2);font-size:13px;left:4px;pointer-events:none;position:absolute;top:29px;transition:color .2s;}
        .lg-field label{color:var(--text2);display:block;font-size:12px;font-weight:600;letter-spacing:.06em;margin-bottom:6px;margin-left:20px;text-shadow:0 1px 4px rgba(0,0,0,.85);text-transform:uppercase;}
        .lg-field input{background:transparent;border:none;border-bottom:1px solid rgba(255,255,255,.28);color:#f2f2f7;font-size:15px;padding:8px 4px 8px 20px;text-shadow:0 1px 4px rgba(0,0,0,.85);width:100%;}
        .lg-field input:focus{outline:none;}
        .lg-field input:focus ~ .lg-ic{color:#8b5cf6;}
        .lg-field .lg-underline{background:linear-gradient(90deg,#8b5cf6,#06b6d4);bottom:0;height:2px;left:50%;position:absolute;transition:width .25s ease,left .25s ease;width:0;}
        .lg-field input:focus ~ .lg-underline{left:0;width:100%;}
        /* Bloqueia o fundo branco/amarelo que o Chrome injeta em campos
           autopreenchidos, mantendo o campo transparente mesmo com
           autofill ativo -- essa é a causa real do "campo branco". */
        .lg-field input:-webkit-autofill,
        .lg-field input:-webkit-autofill:hover,
        .lg-field input:-webkit-autofill:focus{
          -webkit-text-fill-color:#f2f2f7;
          -webkit-box-shadow:0 0 0px 1000px transparent inset;
          transition:background-color 9999s ease-in-out 0s;
        }
        .lg-back-btn{
          align-items:center;background:rgba(255,255,255,0.06);backdrop-filter:blur(10px) saturate(150%);
          -webkit-backdrop-filter:blur(10px) saturate(150%);border:1px solid rgba(255,255,255,0.14);
          border-radius:999px;box-shadow:0 8px 24px -8px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.12);
          color:#f1f5f9;cursor:pointer;display:flex;font-size:13px;font-weight:600;gap:8px;
          padding:9px 18px 9px 14px;transition:background .2s,border-color .2s,transform .2s;
        }
        .lg-back-btn:hover{background:rgba(59,130,246,0.12);border-color:rgba(59,130,246,0.4);transform:translateX(-2px);}
      `}</style>
      {/* Botão de voltar -- vidro flutuante, canto superior esquerdo,
          leva de volta pra landing page. */}
      <button type="button" className="lg-back-btn" onClick={() => navigate("/")} style={{ position: "fixed", top: 24, left: 24, zIndex: 5 }}>
        <span aria-hidden="true">←</span> {t("common.voltar")}
      </button>
      {/* Fundo animado "warp" (raios radiais) atrás do card de login. Sem
          background própria neste wrapper -- o fundo geral já vem do
          body (global.css var(--bg)), igual à referência aprovada
          (5-fusao-grid-particulas.html), pra não ter nenhuma camada opaca
          extra entre o canvas e o vidro do card. */}
      <Nebulosa />
      <WarpBackground />
      {/* .login-card (wrapper, 100% transparente, só posiciona) */}
      <div style={{ background: "transparent", maxWidth: 380, padding: 0, position: "relative", width: "100%", zIndex: 1 }}>
        {/* .login-inner (o vidro de verdade -- valores exatos da referência:
            fundo quase transparente + backdrop-filter, SEM borda, só
            sombra por baixo pra dar sensação de flutuação) */}
        <div style={{ background: "rgba(20,20,34,0.10)", backdropFilter: "blur(6px) saturate(155%)", WebkitBackdropFilter: "blur(6px) saturate(155%)", border: "none", borderRadius: 16, boxShadow: "0 30px 70px -20px rgba(0,0,0,0.55)", overflow: "hidden", padding: "32px 26px", position: "relative" }}>
        <div aria-hidden="true" style={{ position: "absolute", inset: 0, backgroundImage: `url(${logoAS})`, backgroundRepeat: "no-repeat", backgroundPosition: "center 46%", backgroundSize: "82% auto", opacity: 0.24, pointerEvents: "none" }} />
        <div aria-hidden="true" style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at center 46%, rgba(10,10,16,.14) 0%, rgba(10,10,16,.34) 62%, rgba(10,10,16,.28) 100%)", pointerEvents: "none" }} />
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <LanguageSwitcher dark={false} />
        </div>
        {/* Sem badge pequeno de logo -- só o texto da marca. A imagem do
            logo aparece unicamente como marca d'água grande atrás (acima),
            igual à referência. */}
        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <div style={{ fontSize: 22, fontWeight: 800, textShadow: "0 1px 5px rgba(0,0,0,.9), 0 0 22px rgba(0,0,0,.6)" }}>{sistema.nome}</div>
          <div style={{ color: "var(--text2)", fontSize: 12, textShadow: "0 1px 4px rgba(0,0,0,.85)" }}>{t("login.subtitle")}</div>
        </div>
        {erro && <div style={{ background: "#dc262220", border: "1px solid #dc2626", borderRadius: 8, color: "#fca5a5", fontSize: 13, marginBottom: 16, padding: "10px 14px" }}>{erro}</div>}
        {/* name/autoComplete proprios deste login (oficina) -- distintos do
            login do Painel Central (admin-panel/Login.js). Os dois formularios
            vivem na mesma origem (saas-gl.duckdns.org), so que em paths
            diferentes (/ vs /admin-panel). O gerenciador de senhas do
            navegador guarda credenciais por ORIGEM, nao por path, entao ele
            enxerga os dois logins como "o mesmo site" -- e por isso pode
            sugerir atualizar uma senha salva de um painel quando voce loga
            no outro. Isso e so o navegador perguntando (nao mistura sessao
            nem dado nenhum, o backend valida tudo de novo); nomes/autocomplete
            proprios ajudam a reduzir a confusao. */}
        <form onSubmit={enviar} style={{ display: "flex", flexDirection: "column", gap: 16 }} autoComplete="on">
          {/* Campos "de vidro" -- ícone + label + input transparente +
              sublinhado que acende no foco, igual ao mockup original
              (.field). Autofill do navegador é neutralizado no <style>
              acima, pra nunca aparecer fundo branco. */}
          <div className="lg-field">
            <span className="lg-ic">✉</span>
            <label htmlFor="tenant-email">{t("login.email_label")}</label>
            <input id="tenant-email" name="tenant-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} placeholder={t("login.email_placeholder")} required />
            <span className="lg-underline" />
          </div>
          <div className="lg-field">
            <span className="lg-ic">🔒</span>
            <label htmlFor="tenant-password">{t("login.password_label")}</label>
            <input
              id="tenant-password"
              name="tenant-password"
              type={mostrarSenha ? "text" : "password"}
              autoComplete="current-password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              placeholder="••••••••"
              required
              style={{ paddingRight: 30 }}
            />
            <button
              type="button"
              onClick={() => setMostrarSenha(v => !v)}
              title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
              style={{ position: "absolute", right: 2, top: 27, background: "none", border: "none", color: "var(--text2)", cursor: "pointer", fontSize: 15, padding: 4 }}
            >
              {mostrarSenha ? "🙈" : "👁️"}
            </button>
            <span className="lg-underline" />
          </div>
          <div style={{ textAlign:"right", marginBottom:16 }}>
            <a href="/esqueci-senha" style={{ color:"#8b93ff", fontSize:13, textDecoration:"none", textShadow: "0 1px 4px rgba(0,0,0,.85)" }}>{t("login.forgot_password")}</a>
          </div>
          <button type="submit" className="btn-primary" style={{ marginTop: 8, padding: "12px" }} disabled={loading}>
            {loading ? t("login.submitting") : t("login.submit")}
          </button>
        </form>
        </div>
      </div>
    </div>
  );
}
